/**
 * Created by Ning Jiang on 11/22/2016.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {GameModelEvent} from "@nolimitcity/slot-game/bin/model/GameModel";
import {LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {DumpsterFireGameAssets} from "./DumpsterFireGameAssets";
import {DumpsterFireSound} from "./sound/DumpsterFireSound";
import {DumpsterFireBackgroundElements} from "./view/DumpsterFireBackgroundElements";
import {DumpsterFireWinPresentation} from "./gameflow/base/DumpsterFireWinPresentation";
import {DumpsterFireNormalBetPresentation} from "./gameflow/base/DumpsterFireNormalBetPresentation";
import {DumpsterFireNormalResultPresentation} from "./gameflow/base/DumpsterFireNormalResultPresentation";
import {DumpsterFireIdleNormalPresentation} from "./gameflow/base/DumpsterFireIdleNormalPresentation";
import {DumpsterFireZeroBetIdlePresentation} from "./gameflow/DumpsterFireZeroBetIdlePresentation";
import {DumpsterFireGameData, ISymbolValues} from "./server/DumpsterFireData";
import {DumpsterFireModel, spineConfig} from "./server/DumpsterFireModel";
import {DFReelAreaView} from "./reels/DFReelAreaView";
import {DFAvalancheIdlePresentation} from "./gameflow/avalanche/DFAvalancheIdlePresentation";
import {DFAvalancheFillUpReelsPresentation} from "./gameflow/avalanche/DFAvalancheFillUpdPresentation";
import {DFAvalancheBetPresentation} from "./gameflow/avalanche/DFAvalancheBetPresentation";
import {DumpsterFireGameMode} from "./server/DumpsterFireGameMode";
import {DFFSIntroView} from "./view/DFFSIntroView";
import {DFFSOutroView} from "./view/DFFSOutroView";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {DFTotalWinView} from "./view/DFTotalWinView";
import {gsap, TimelineLite} from "gsap";
import {DFWinView} from "./view/DFWinView";
import {DFScatterView} from "./view/DFScatterView";
import {DFWinCapView} from "./view/DFWinCapView";
import {DFXWaysView} from "./view/DFXWaysView";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {UpgradeBet} from "./components/UpgradeBet";
import {DFBlackBgView} from "./view/DFBlackBgView";
import {DFBigWinView} from "./view/DFBigWinView";
import {DFXIView} from "./view/DFXIView";
import {AlfaSlabOne, ariblk} from "./Fonts";
import {DFFSIdlePresentation} from "./gameflow/DFFSIdlePresentation";
import {DFReelAnticipation} from "./presentation/baseGame/DFReelAnticipation";
import {DFTransitionView} from "./view/DFTransitionView";
import {DFWinMulti} from "./view/DFWinMulti";
import {GameLogo} from "./view/GameLogo";
import {FireAnim} from "./view/FireAnim";
import {BgMultiplierView} from "./view/BgMultiplierView";
import {DumpsterFireSymbol, SYMBOL_NAME} from "./reels/DumpsterFireSymbol";
import {finalMultiView} from "./view/finalMultiView";
import {ISymbol} from "../core/reel/simplereel/IReelData";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {GameInfoEventData} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/GameInfo";
import {Skinner} from "@nolimitcity/slot-keypad/bin/core/loaders/Skinner";
import {AssetLoader} from "@nolimitcity/slot-keypad/bin/core/loaders/assetloader/AssetLoader";
import {FontLoader} from "@nolimitcity/slot-keypad/bin/core/loaders/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-keypad/bin/core/app/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-keypad/bin/core/loaders/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-keypad/bin/core/loaders/assetloader/AssetsConfig";
import {ResourcesGroupName} from "@nolimitcity/slot-keypad/bin/core/loaders/assetloader/ResourcesGroupName";

export class DumpsterFire extends SlotGame {

    public static boostedName: string = "BOOSTED_BET";
    public static model: DumpsterFireModel;
    public static assetLoader: AssetLoader;
    public static soundPlayer: DumpsterFireSound;
    public static backgroundElements: DumpsterFireBackgroundElements;
    public static gameFlowController: GameFlowController;
    public static allReelsView: DFReelAreaView;
    public static fsIntro: DFFSIntroView;
    public static fsOutro: DFFSOutroView;
    public static buyFeatureName: string = "";
    public static totalWinView: DFTotalWinView;
    public static winView: DFWinView;
    public static scatterView: DFScatterView;
    public static winCapView: DFWinCapView;
    public static xWaysView: DFXWaysView;
    public static xInfectiousWaysView: DFXIView;
    public static upgradeBet: UpgradeBet;
    public static blackBg: DFBlackBgView;
    public static bigWinView: DFBigWinView;
    public static reelAnticipation: DFReelAnticipation;
    public static transitionView: DFTransitionView;
    public static winMultiView: DFWinMulti;
    public static fireFrame: FireAnim;
    public static gameLogo: GameLogo;
    public static bgMulti: BgMultiplierView;
    public static bgFinalMulti: finalMultiView;
    public static symbolsToBeCensored: string[] = ["M2"]; //
    public static imagesToBeCensored: string[] = ["pageImage_1.png", "pageImage_2.png", "pageImage_3.png", "pageImage_12.png"]; // censored
    public static isNJServer: boolean = false;
    public static isUSJurisdiction: boolean = false;
    public static gameInfoData: GameInfoEventData;


    public static preMultiPosArray: number[][] = [[1, 1, 1, 1, 1], [1, 1, 1, 1, 1], [1, 1, 1, 1, 1], [1, 1, 1, 1, 1], [1, 1, 1, 1, 1], [1, 1, 1, 1, 1]];

    private skinner: Skinner;

    constructor() {
        super();
        const validSkins: string[] = [
            "sweep"
        ]
        this.skinner = new Skinner(validSkins);
    }

    private handleSweepInit() {
        //Making sure that skinID is set based  on "replaceWordFree" gcc.
        if (SlotGame.apiPlugin.gameClientConfiguration.isSet) {
            if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                this.skinner.skinId = "sweep";
            }
            if (SlotGame.apiPlugin.gameClientConfiguration.jurisdictionName.includes("US")) {
                DumpsterFire.isUSJurisdiction = true;
            }
        } else {
            SlotGame.apiPlugin.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                    this.skinner.skinId = "sweep";
                }
                if (SlotGame.apiPlugin.gameClientConfiguration.jurisdictionName.includes("US")) {
                    DumpsterFire.isUSJurisdiction = true;
                }
            })
        }
    }

    private handleSweepGetReady(): Promise<any> {
        if (this.skinner.skinId != undefined) {
            const replaceMap: Map<string, string> = new Map();
            //Bonus
            replaceMap.set("BOOSTED_BET", "BOOSTED_BET.png");
            replaceMap.set("pageImage_7", "pageImage_7.png");
            return this.skinner.loadSkin(replaceMap);
        }
        return Promise.resolve();
    }

    public static createTimelineForAnimation(spine: PIXI.spine.Spine, trackIndex: number, animationName: string, loop: boolean, animationAlpha: number = 1, mixDuration: number = 0, resetOnComplete: boolean = true): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            repeat: loop ? -1 : 0
        });

        // trying safe checks for #136
        if (!spine.spineData || !spine.state) {
            return tl;
        }

        let animation: PIXI.spine.core.Animation = spine.spineData.findAnimation(animationName);
        if (!animation) {
            if (animationName === "landing") {
                animation = spine.spineData.findAnimation("normal");
            } else {
                throw new Error(`No animation named ${animationName}`);
            }
        }
        spine.autoUpdate = false;

        const setAnimation: () => void = () => {
            // trying safe check for #136
            if (spine.state) {
                const trackEntry: PIXI.spine.core.TrackEntry = spine.state.setAnimationWith(trackIndex, animation, false);
                trackEntry.alpha = animationAlpha;
                trackEntry.mixDuration = mixDuration;
            }
        };

        const target = {
            playHead: 0,
            spine: spine,
            prevTime: 0
        };

        const updateFunc: () => void = () => {
            // trying safe checks for #136
            if (spine && target) {
                const now = target.playHead;
                spine.update(now - target.prevTime);
                target.prevTime = now;
            }
        };

        tl.add(() => {
            target.prevTime = 0;
            setAnimation();
        });
        tl.fromTo(target, {playHead: 0}, {
            duration: animation.duration,
            playHead: animation.duration,
            onUpdate: updateFunc,
            ease: "none"
        });
        if (resetOnComplete) {
            tl.add(() => {
                target.prevTime = 0;
                setAnimation();
            });
        }
        tl.to(target, {duration: 0.0001}); //Needed so gsap does not skip "setAnimation" during reverse play.
        tl.add(() => {
            target.playHead = animation.duration;
            updateFunc();
        });

        return tl;
    }

    public static isWinBelowStake(): boolean {
        return this.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (this.model.data.accumulatedRoundWin <= this.getBuyFeaturePrice());
    }

    public static isESWinBelowStake(): boolean {
        return this.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && ((this.model.data.accumulatedRoundWin - this.model.data.extraSpinCost) <= this.getBuyFeaturePrice());
    }

    public static getBuyFeaturePrice(): number {
        const betLevel: string = DumpsterFire.apiPlugin.freeBets.hasFreeBets() ? DumpsterFire.apiPlugin.freeBets.getBet() : DumpsterFire.apiPlugin.betLevel.getLevel();
        let price: number = DumpsterFire.model.gameData?.playedBetValue || parseFloat(betLevel);
        if (this.buyFeatureName || DumpsterFire.model.data.boostedBet) {
            for (let index: number = 0; index < DumpsterFire.model.initData.featureBuyTimesBetValue.length; index++) {
                if (DumpsterFire.model.initData.featureBuyTimesBetValue[index].name === this.buyFeatureName) {
                    price *= DumpsterFire.model.initData.featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        return MathHelper.ceilToDecimals(price, 2);
    }

    getNoWinGameData(): any {
        return {
            "reels": [[
                "M4",
                "L5",
                "M3",
                "L1",
                "L2"
            ], [
                "L1",
                "L4",
                "M1",
                "M4",
                "M3"
            ], [
                "L1",
                "L3",
                "M2",
                "M3",
                "L5"
            ], [
                "L5",
                "M3",
                "L2",
                "M2",
                "L1"
            ], [
                "M4",
                "L5",
                "M3",
                "L5",
                "L1"
            ], [
                "M4",
                "L5",
                "M3",
                "L5",
                "L1"
            ]],
            "boostedBet": false,
            "brokeTheBank": false,
            "evaluatedReels": [
                [
                    "M4",
                    "L5",
                    "M3",
                    "L1",
                    "L2"
                ], [
                    "L1",
                    "L4",
                    "M1",
                    "M4",
                    "M3"
                ], [
                    "L1",
                    "L3",
                    "M2",
                    "M3",
                    "L5"
                ], [
                    "L5",
                    "M3",
                    "L2",
                    "M2",
                    "L1"
                ], [
                    "M4",
                    "L5",
                    "M3",
                    "L5",
                    "L1"
                ], [
                    "M4",
                    "L5",
                    "M3",
                    "L5",
                    "L1"
                ]
            ],
            "reelsAfterAvalanche": [
                [
                    "M4",
                    "L5",
                    "M3",
                    "L1",
                    "L2"
                ], [
                    "L1",
                    "L4",
                    "M1",
                    "M4",
                    "M3"
                ], [
                    "L1",
                    "L3",
                    "M2",
                    "M3",
                    "L5"
                ], [
                    "L5",
                    "M3",
                    "L2",
                    "M2",
                    "L1"
                ], [
                    "M4",
                    "L5",
                    "M3",
                    "L5",
                    "L1"
                ], [
                    "M4",
                    "L5",
                    "M3",
                    "L5",
                    "L1"
                ]
            ],
            "extraSpinCount": 0,
            "extraSpinCost": 0,
            "positionMultipliers": [
                [1, 1, 1, 1, 1],
                [1, 1, 1, 1, 1],
                [1, 1, 1, 1, 1],
                [1, 1, 1, 1, 1],
                [1, 1, 1, 1, 1],
                [1, 1, 1, 1, 1]
            ],
            "spinWin": 0,
            "scatterWins": [],
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "freespinsLeft": 0,
            "upgradedSymbols": [],
            "wasFeatureBuy": false,
            "xWaysMultipliers": [
                [0, 0, 0, 0, 0],
                [0, 0, 0, 0, 0],
                [0, 0, 0, 0, 0],
                [0, 0, 0, 0, 0],
                [0, 0, 0, 0, 0],
                [0, 0, 0, 0,]
            ],
        };
    }

    public init(): Promise<NolimitPlugin> {
        return super.init().then((value: NolimitPlugin) => {
            DumpsterFire.model = new DumpsterFireModel(SlotGame.apiPlugin, true);
            DumpsterFire.gameFlowController = new GameFlowController(SlotGame.apiPlugin, DumpsterFire.model);
            DumpsterFire.gameFlowController.flowStateLogger.level = LogLevel.DEV;

            //Example
            DumpsterFire.model.events?.on(GameModelEvent.GAME, (data: DumpsterFireGameData) => {
                console.log(data);
            });


            DumpsterFire.isNJServer=!!(SlotKeypad.apiPlugIn.options && SlotKeypad.apiPlugIn.options.game && SlotKeypad.apiPlugIn.options.game.indexOf("NJ") > -1);

            DumpsterFire.apiPlugin.events.on(APIEvent.GAME_INFO, (data: any) => {
                DumpsterFire.gameInfoData = data;
            });

            const winPres = new DumpsterFireWinPresentation();
            const idleNormal = new DumpsterFireIdleNormalPresentation();
            const reelStart = new DumpsterFireNormalBetPresentation();
            const normalResult = new DumpsterFireNormalResultPresentation();
            const zeroBetIdle = new DumpsterFireZeroBetIdlePresentation();
            const fsIdle = new DFFSIdlePresentation();

            const avalancheIdle = new DFAvalancheIdlePresentation();
            const avalancheBet = new DFAvalancheBetPresentation();
            const avalancheResult = new DFAvalancheFillUpReelsPresentation();


            DumpsterFire.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, idleNormal],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winPres]
            ]));
            DumpsterFire.gameFlowController.addGameModeFlowStatePresentationMap(DumpsterFireGameMode.NORMAL_AVALANCHE, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, avalancheIdle],
                [FlowState.BET, avalancheBet],
                [FlowState.RESULT, avalancheResult],
                [FlowState.WIN, winPres]
            ]));

            DumpsterFire.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, fsIdle],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winPres]
            ]));

            DumpsterFire.gameFlowController.addGameModeFlowStatePresentationMap(DumpsterFireGameMode.FREESPIN_AVALANCHE, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, avalancheIdle],
                [FlowState.BET, avalancheBet],
                [FlowState.RESULT, avalancheResult],
                [FlowState.WIN, winPres]
            ]));

            DumpsterFire.gameFlowController.addGameModeFlowStatePresentationMap(DumpsterFireGameMode.EXTRA_SPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, {
                    start: (flowStateController: FlowStateController) => {
                        if (DumpsterFire.model.shouldPlayExtraBet()) {
                            if (DumpsterFire.apiPlugin.isReplay)
                                DumpsterFire.upgradeBet.replay(flowStateController);
                            else {
                                DumpsterFire.upgradeBet.enable(flowStateController);
                            }
                        } else {
                            DumpsterFire.apiPlugin.betHandler.zeroBet();
                            flowStateController.finish();
                        }
                    }
                }],
                [FlowState.RESULT, {start: (flowStateController: FlowStateController) => flowStateController.finish()}],
                [FlowState.WIN, {start: (flowStateController: FlowStateController) => flowStateController.finish()}]
            ]));
            this.handleSweepInit();
            return value;
        });
    }

    public getReady(): Promise<NolimitPlugin> {
        //Show intro and load game assets
        return super.getReady().then((value: NolimitPlugin) => {

            const fontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);
            fontLoader.add(AlfaSlabOne.REGULAR);
            fontLoader.add(ariblk.REGULAR);

            AssetsConfig.addToAssetsConfig(DumpsterFireGameAssets.RESOURCES_GROUPS);
            DumpsterFire.assetLoader = new AssetLoader(DumpsterFire.apiPlugin, NolimitApplication.resourcePath + "/resources/");

            const promises = Promise.all([fontLoader.load(), DumpsterFire.assetLoader.load(ResourcesGroupName.MAIN), this.handleSweepGetReady()]);

            return promises.then((values: any) => {

                this.createViewsAndComponents();

                //if(DumpsterFire.model.initData.isRestoreState) {
                //DumpsterFire.reelArea.restoreReels();
                //}

                return value;
            });
        });
    }

    public static getSpineDuration(spineObj: PIXI.spine.Spine, animName: string): number {
        return spineObj.skeleton.data.findAnimation(animName).duration;
    }

    public static resetSpine(spineObj: PIXI.spine.Spine, show: boolean = false): void {
        spineObj.state.clearTracks();
        spineObj.skeleton.setToSetupPose();
        spineObj.skeleton.setBonesToSetupPose();
        spineObj.skeleton.setSlotsToSetupPose();
        spineObj.state.setEmptyAnimation(0, 0);
        spineObj.visible = show;
    }

    public static playSpineAnimationFromParams(params: spineConfig): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            currSpine: PIXI.spine.Spine = params.spineItem,
            animName: string = params.animation,
            skinName: string = params.skin ? params.skin : "default",
            isLooped: boolean = params.playLoop ? params.playLoop : false,
            animTotalDur: number = this.getSpineDuration(currSpine, animName),
            startTime: number = params.startTime ? params.startTime : 0,
            endTime: number = params.endTime ? params.endTime : animTotalDur;

        tl.to(this, {
            duration: Math.max(0.033, (endTime - startTime)),
            onStart: () => {
                this.resetSpine(currSpine, true);
                currSpine.skeleton.setSkinByName(skinName);
                currSpine.state.setAnimation(0, animName, isLooped);

                if (params.startTime !== undefined) {
                    currSpine.state.tracks[0].trackTime = 0;
                    currSpine.update(startTime);
                }

                if (params.endTime !== undefined) {
                    currSpine.state.tracks[0].trackEnd = endTime;
                }
            }
        });

        return tl;
    }

    public getReadyToStart(): Promise<NolimitPlugin> {
        //Game assets loaded, waiting for user to start game.
        return super.getReadyToStart().then((value: NolimitPlugin) => {
            DumpsterFire.soundPlayer.switchMusic(DumpsterFire.model.data.mode);
            return value;
        });
    }

    public start(): Promise<NolimitPlugin> {
        // @ts-ignore
        // window.parent["game"] = DumpsterFire;
        //User has pressed continue and the game starts.
        return super.start().then((value: NolimitPlugin) => {
            if (DumpsterFire.model.isRestore) {
                DumpsterFire.model.scatterSymArray = [];
                for (let reelId: number = 0; reelId < DumpsterFire.model.data.reels.length; reelId++) {
                    for (let rowId: number = 0; rowId < DumpsterFire.model.data.reels[reelId].length; rowId++) {
                        if (DumpsterFire.model.data.reels[reelId][rowId] === SYMBOL_NAME.SCATTER) {
                            let symbol: ISymbol = DumpsterFire.allReelsView.getSymbolAtPosition(reelId, rowId);
                            DumpsterFire.model.scatterCount++
                            DumpsterFire.model.scatterSymArray.push(symbol);
                        }
                    }
                }

                if (DumpsterFire.model.initData.mode === DumpsterFireGameMode.NORMAL_AVALANCHE) {
                    if (DumpsterFire.model.scatterSymArray.length >= 2) {
                        DumpsterFire.model.scatterSymArray.forEach((symItem: ISymbol) => {
                            DumpsterFire.winView.playGlowAnimation(<DumpsterFireSymbol>symItem);
                        })
                    }
                }

                if (DumpsterFire.model.scatterCount === 5) {
                    DumpsterFire.model.scatterCount++;
                }
                DumpsterFire.backgroundElements.activeUpgradedSymbol();
                DumpsterFire.gameLogo.setMode(DumpsterFire.model.data.nextMode);
                DumpsterFire.backgroundElements.setMode(DumpsterFire.model.data.nextMode);
                DumpsterFire.allReelsView.addAllSymMulti(DumpsterFire.model.data.positionMultipliers);
                if (((DumpsterFire.model.data.mode.indexOf("NORMAL") > -1 || DumpsterFire.model.data.mode.indexOf("FREESPIN") > -1 || DumpsterFire.model.data.mode.indexOf("EXTRA_SPIN") > -1) && DumpsterFire.model.data.nextMode.indexOf("FREESPIN") > -1) ||
                    (DumpsterFire.model.data.mode.indexOf("EXTRA_SPIN") > -1 || DumpsterFire.model.data.mode.indexOf("FREESPIN") > -1) && (DumpsterFire.model.data.nextMode.indexOf("NORMAL") > -1 || DumpsterFire.model.data.nextMode.indexOf("EXTRA_SPIN") > -1)) {
                    DumpsterFire.model.isFreespin = true;
                    DumpsterFire.soundPlayer.getRestoreSound(DumpsterFire.bgMulti.largestMulti());
                }
                if (DumpsterFire.model.data.mode.indexOf("FREESPIN") > -1 || DumpsterFire.model.data.nextMode.indexOf("FREESPIN") > -1) {
                    DumpsterFire.keypadPlugin.setZeroBetSpinCounter(Math.max(DumpsterFire.model.data.freespinsLeft - 1, 0));
                }
                DumpsterFire.model.calculatePrevMultiPos();
            }
            DumpsterFire.gameFlowController.start();
            return value;
        });
    }

    private static getSymbolString(key: string, data: { [numSymbols: number]: number }): string {
        const gameMultiplier: number = 20;
        const twelveLengthWin: number = data[12] / gameMultiplier;
        const elevenLengthWin: number = data[11] / gameMultiplier;
        const tenLengthWin: number = data[10] / gameMultiplier;
        const nineLengthWin: number = data[9] / gameMultiplier;
        const eightLengthWin: number = data[8] / gameMultiplier;
        return `
            <div class="symbol">
            <img src="{{gamePath}}screens/images/symbols/${key}.png">
            <div class="payout-group">
                <div class="payout">
                    <span style="margin-left: 0.6em" class="number">12+</span>
                    <span style="margin-left: 0.3em" class="multiplier" data-multiplier="${twelveLengthWin}">${twelveLengthWin}</span>
                </div>
                <div class="payout">   
                <span style="margin-left: -0.3em ;padding-right:-0.16em" class="number">10-11</span>
                    <span style="margin-left: 0.3em"  class="multiplier" data-multiplier="${tenLengthWin}">${tenLengthWin}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 0.6em ;padding-right:0.7em" class="number">8-9</span>
                    <span style="margin-left: 0.3em" class="multiplier" data-multiplier="${eightLengthWin}">${nineLengthWin}</span>
                </div>
            </div>
            </div>
        `;
    }

    private paytable: string = require("../../nolimit/screens/paytable.mustache");

    public getPaytable(): Promise<string> {
        return new Promise((resolve, reject) => {
            const data = Object.assign(DumpsterFire.apiPlugin.gameClientConfiguration);
            data.skinPath = "screens/images/"
            data.isNJserver = !!(SlotKeypad.apiPlugIn.options && SlotKeypad.apiPlugIn.options.game && SlotKeypad.apiPlugIn.options.game.indexOf("NJ") > -1);
            data.isUSPAServerAndJuris = ((!!(SlotKeypad.apiPlugIn.options && SlotKeypad.apiPlugIn.options.game && SlotKeypad.apiPlugIn.options.game.indexOf("PA") > -1)) && data.jurisdictionName === "US-PA");//#426
            data.isUSMIorCTorWV = data.jurisdictionName === "US-MI" || data.jurisdictionName === "US-CT" || data.jurisdictionName === "US-WV";//#432
            if (this.skinner.skinId != undefined) {
                data.skinPath = `../resources/images/${this.skinner.skinId}/`;
            }
            const symbolDataValueData: ISymbolValues = DumpsterFire.model.initData.symbolValues;
            let paytableString: string = (<any>this.paytable).text;
            paytableString = paytableString.replace(/{{skinPath}}/g, data.skinPath);
            if (DumpsterFire.isUSJurisdiction) {
                const pagesToReplace: number[] = [1, 2, 3, 12];
                for (const page of pagesToReplace) {
                    paytableString = paytableString.replace(
                        `pageImage_${page}.png`,
                        `pageImage_${page}_US_new.png`
                    );
                }
            }
            if (data.isNJserver) {
                paytableString = paytableString.replace("pageImage_12.png", "MaxWin_NJ_US_50000x.png");
            }
            for (let key in symbolDataValueData) {
                let nameKey: string = key;
                if (DumpsterFire.symbolsToBeCensored.includes(nameKey) && DumpsterFire.isUSJurisdiction) {
                    nameKey += "_US_new";
                }
                paytableString = paytableString.replace(`{{${key}}}`, DumpsterFire.getSymbolString(nameKey, symbolDataValueData[key]));
                paytableString = paytableString.replace(new RegExp("#extraSpinAllowed", "g"), (!data.isNJserver /*&& data.isExtraSpinFeature*/ ? "" : "extraSpinsNotAllowed"));
            }

            let translatedContent: string = DumpsterFire.apiPlugin.translations.render(paytableString, data);
            resolve(translatedContent);
        });
    }

    private rules: string = require("../../nolimit/screens/rules.mustache").text;
    public async getGameRules(): Promise<string> {
        let value = this.rules;
        const data: any = Object.assign(DumpsterFire.apiPlugin.gameClientConfiguration);
        const isNJserver: boolean = !!(SlotKeypad.apiPlugIn.options && SlotKeypad.apiPlugIn.options.game && SlotKeypad.apiPlugIn.options.game.indexOf("NJ") > -1);
      //  const isExtraSpinFeature: boolean = DumpsterFire.model.initData.featureBuyTimesBetValue.some((feature: any) => feature.name === "EXTRA_SPIN");
        value = value.replace(new RegExp("#actionSpinsAllowed", "g"), (DumpsterFire.apiPlugin.gameClientConfiguration.actionSpin ? "" : "actionSpinsNotAllowed"));
        value = value.replace(new RegExp("#extraSpinAllowed", "g"), (!isNJserver /*&& isExtraSpinFeature*/ ? "" : "extraSpinsNotAllowed"));

        let translatedContent: string = DumpsterFire.apiPlugin.translations.render(value, data);
        translatedContent = translatedContent.replace(new RegExp("XX", "g"), (DumpsterFire.apiPlugin.gameClientConfiguration.extraSpinAllowed ? DumpsterFire.apiPlugin.gameClientConfiguration.gambleGameRoundCloseIntervalHours.toString() : ""));
        return translatedContent;

    }

    private createViewsAndComponents() {
        //Non views
        DumpsterFire.soundPlayer = new DumpsterFireSound();

        //Static views
        DumpsterFire.backgroundElements = new DumpsterFireBackgroundElements();
        DumpsterFire.backgroundElements.setMode(DumpsterFire.model.data.nextMode);
        DumpsterFire.gameLogo = new GameLogo();
        DumpsterFire.gameLogo.setMode(DumpsterFire.model.data.nextMode);
        DumpsterFire.allReelsView = new DFReelAreaView();
        DumpsterFire.fsIntro = new DFFSIntroView();
        DumpsterFire.fsOutro = new DFFSOutroView();
        DumpsterFire.totalWinView = new DFTotalWinView();
        DumpsterFire.winView = new DFWinView();
        DumpsterFire.scatterView = new DFScatterView();
        DumpsterFire.winCapView = new DFWinCapView();
        DumpsterFire.xWaysView = new DFXWaysView();
        DumpsterFire.upgradeBet = new UpgradeBet();
        DumpsterFire.blackBg = new DFBlackBgView();
        DumpsterFire.bigWinView = new DFBigWinView();
        DumpsterFire.xInfectiousWaysView = new DFXIView();
        DumpsterFire.reelAnticipation = new DFReelAnticipation();
        DumpsterFire.transitionView = new DFTransitionView();
        DumpsterFire.winMultiView = new DFWinMulti();
        DumpsterFire.fireFrame = new FireAnim();
        DumpsterFire.bgMulti = new BgMultiplierView();
        DumpsterFire.bgFinalMulti = new finalMultiView();

        NolimitApplication.addLayerAt(DumpsterFire.transitionView.name, DumpsterFire.transitionView, 0);
        NolimitApplication.addLayerAt(DumpsterFire.winCapView.name, DumpsterFire.winCapView, 0);
        NolimitApplication.addLayerAt(DumpsterFire.bigWinView.name, DumpsterFire.bigWinView, 0);
        NolimitApplication.addLayerAt(DumpsterFire.fsIntro.name, DumpsterFire.fsIntro, 0);
        NolimitApplication.addLayerAt(DumpsterFire.fsOutro.name, DumpsterFire.fsOutro, 0);
        NolimitApplication.addLayerAt(DumpsterFire.blackBg.name, DumpsterFire.blackBg, 0);
        NolimitApplication.addLayerAt(DumpsterFire.gameLogo.name, DumpsterFire.gameLogo, 0);
        NolimitApplication.addLayerAt(DumpsterFire.upgradeBet.name, DumpsterFire.upgradeBet, 0);
        NolimitApplication.addLayerAt(DumpsterFire.xInfectiousWaysView.name, DumpsterFire.xInfectiousWaysView, 0);
        NolimitApplication.addLayerAt(DumpsterFire.xWaysView.name, DumpsterFire.xWaysView, 0);
        NolimitApplication.addLayerAt(DumpsterFire.scatterView.name, DumpsterFire.scatterView, 0);
        NolimitApplication.addLayerAt(DumpsterFire.winView.name, DumpsterFire.winView, 0);
        NolimitApplication.addLayerAt(DumpsterFire.totalWinView.name, DumpsterFire.totalWinView, 0);
        NolimitApplication.addLayerAt(DumpsterFire.winMultiView.name, DumpsterFire.winMultiView, 0);
        NolimitApplication.addLayerAt(DumpsterFire.allReelsView.name, DumpsterFire.allReelsView, 0);
        NolimitApplication.addLayerAt(DumpsterFire.reelAnticipation.name, DumpsterFire.reelAnticipation, 0);
        NolimitApplication.addLayerAt(DumpsterFire.bgFinalMulti.name, DumpsterFire.bgFinalMulti, 0);
        NolimitApplication.addLayerAt(DumpsterFire.fireFrame.name, DumpsterFire.fireFrame, 0);
        NolimitApplication.addLayerAt(DumpsterFire.bgMulti.name, DumpsterFire.bgMulti, 0);
        NolimitApplication.addLayerAt(DumpsterFire.backgroundElements.name, DumpsterFire.backgroundElements, 0);
        // SpineViewUtils.init(DumpsterFireGameAssets.RESOURCES_GROUPS.main, DumpsterFire.assetLoader);
    }
}